export interface Message {
  id: string
  type: 'user' | 'ai'
  content: string
  timestamp: Date
}

export interface CodeContext {
  transcribedThoughts: string
  currentCode: string
  filePath: string
  language: string
  problemDescription?: string
  conversationMode?: boolean
  previousMessages?: Message[]
}

export interface VoiceInputProps {
  onTranscript: (transcript: string) => void
  isListening: boolean
  setIsListening: (listening: boolean) => void
  disabled?: boolean
}

export interface CodeEditorProps {
  value: string
  onChange: (value: string) => void
  language: string
}

export interface FeedbackPanelProps {
  messages: Message[]
  isProcessing: boolean
  messagesEndRef: React.RefObject<HTMLDivElement>
  feedbackPanelRef?: React.RefObject<HTMLDivElement>
}

export interface HeaderProps {
  onClearSession: () => void
}

export interface TestCase {
  input: string
  expectedOutput: string
  description?: string
}

export interface Problem {
  id: string
  title: string
  description: string
  starterCode?: string
  difficulty?: 'Easy' | 'Medium' | 'Hard'
  tags?: string[]
  testCases?: TestCase[]
  supportedLanguages?: string[]
}

// Authentication types
export interface User {
  id: string
  email: string
  name: string
  avatar?: string
  createdAt: string
  updatedAt: string
  preferences?: {
    theme?: 'light' | 'dark'
    language?: string
    notifications?: boolean
  }
}

export class AuthError extends Error {
  constructor(message: string) {
    super(message)
    this.name = 'AuthError'
  }
} 